module.exports = __webpack_public_path__ + "static/media/Montana2924.3eef46a6.jpg";